import { sendGenericEvent } from 'analytics/events/generics/sendGenericEvent'

const SizeGuideAction = 'size_guide_action'

export const sendLineChangeClick = () => {
	sendGenericEvent(SizeGuideAction, {
		label_1: 'brand',
	})
}

export const sendFamilyChangeClick = () => {
	sendGenericEvent(SizeGuideAction, {
		label_1: 'family',
	})
}

export const sendRegionsChangeClick = () => {
	sendGenericEvent(SizeGuideAction, {
		label_1: 'size_country',
	})
}

export const sendUnitsChangeClick = () => {
	sendGenericEvent(SizeGuideAction, {
		label_1: 'unit',
	})
}
